import Anchor from 'antd/lib/anchor'

import 'antd/lib/anchor/style'

export * from 'antd/lib/anchor'

export default Anchor
